import { definePiniaStore } from "#imports";

/**
 * Persists the last-used ticket-list URL query (filters, live/analysis mode and
 * page number) to localStorage via pinia-plugin-persistedstate, so the exact
 * same view can be restored when an agent leaves the ticket-list page (to view
 * a ticket or a profile) and comes back through the sidebar / a fresh load.
 *
 * Only the normal ticket-list page reads/writes this store. The automation
 * (AI) tickets page manages its own state and never touches it.
 */
export const useTicketListPersistFilter = definePiniaStore(
  "ticketListPersistFilter",
  {
    state: () => ({
      _query: {} as Record<string, any>,
    }),
    persist: true,
    actions: {
      setQuery(query: Record<string, any>) {
        this._query = { ...query };
      },
      clearQuery() {
        this._query = {};
      },
    },
    getters: {
      savedQuery: (state) => state._query,
    },
  },
);
